import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, signal } from '@angular/core';

import { MenuItemType } from '../detail-action-button/detail-action-buttons.const';
import { MenuItem, MenuItemTypeConfigurations } from '../detail-action-button/detail-action-buttons.types';

import { DetailAction, DetailActionFlow } from './detail-dialog.types';

@Component({
  selector: 'app-detail-dialog',
  templateUrl: './detail-dialog.component.html',
  styleUrl: './detail-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DetailDialogComponent implements OnInit {
  @Input() set item(menuItem: MenuItem) {
    const config = menuItem.typeOptions as MenuItemTypeConfigurations[MenuItemType.DIALOG];
    this.action.set(config.action);
  }
  @Output() actionButtonClick = new EventEmitter<string>();

  action = signal<DetailAction>(null);
  actionFlow = signal<DetailActionFlow>(null);
  visible = signal<boolean>(false);
  loading = signal<boolean>(false);

  ngOnInit(): void {
    if (!this.action()) {
      return;
    }

    this.actionFlow.set(this.action()?.config?.flows[0]);
    this.visible.set(true);
  }

  handleActionButtonClick(action: string) {
    this.loading.set(true);
    this.actionButtonClick.emit(action);
  }
}
